import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  /** Desktop collapsed state (icon-only). Persisted. */
  collapsed: boolean;
  /** Mobile drawer state. NOT persisted — should always start closed on a new page. */
  mobileOpen: boolean;
  toggle: () => void;
  setCollapsed: (v: boolean) => void;
  openMobile: () => void;
  closeMobile: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      collapsed:    false,
      mobileOpen:   false,
      toggle:       () => set((s) => ({ collapsed: !s.collapsed })),
      setCollapsed: (v) => set({ collapsed: v }),
      openMobile:   () => set({ mobileOpen: true }),
      closeMobile:  () => set({ mobileOpen: false }),
    }),
    { name: 'grc-sidebar', partialize: (s) => ({ collapsed: s.collapsed }) },
  ),
);
